module.exports = __webpack_public_path__ + "fonts/Lato-400-latin-ext3.633f8fe.woff2";